import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H5: Components["h5"] = ({ children, className, ...rest }) => (
  <h5
    className={cn("af-m-0 af-pt-6 af-text-sm af-font-bold", className)}
    {...rest}
  >
    {children}
  </h5>
);
